import BadgeColumn from './BadgeColumn';

export default BadgeColumn;
